import { useEffect, useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getAuctionIds } from '../../../api/ListSort/getAuctionIds';

const DEBOUNCE_MS = 250;

export default function useGetAuctionIds(listSortId: string | null, query: string, enabled = true) {
  const [ debouncedQuery, setDebouncedQuery ] = useState(query);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(query.trim()), DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [ query ]);

  const auctionIdsQuery = useQuery({
    queryKey: [ 'getAuctionIds', listSortId, debouncedQuery ],
    queryFn: () => getAuctionIds(listSortId, debouncedQuery),
    enabled: enabled && !!listSortId,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });

  return {
    auctionIds: auctionIdsQuery.data ?? [],
    isLoadingAuctionIds: auctionIdsQuery.isFetching,
  };
}
